<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'management'" :href="'#management'">{{ $t('Management') }}</v-tab>
        <!-- <v-tab ripple :key="'agent'" :href="'#agent'">{{ $t('Agent') }}</v-tab> -->
        <!-- <v-tab ripple :key="'funnel'" :href="'#funnel'">{{ $t('Funnel') }}</v-tab> -->
      </v-tabs>

      <div v-if="tabs == 'management' && !loading">
        <Management></Management>
      </div>
      <div v-if="tabs == 'agent'">
        <Agent></Agent>
      </div>
      <div v-if="tabs == 'funnel'">
        <Funnel></Funnel>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Management from './Management.vue'
import Agent from './Agent.vue'
import Funnel from './Funnel.vue'
export default {
  components: {
    Agent,
    Funnel,
    Management
  },
  data() {
    return {
      loading: true,
      tabs: 'management'
    }
  },
  async created() {
    this.$store.dispatch('loading')
    this.loading = true
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.loading = false
    this.$store.dispatch('loading')
    // let vm = this
    // if (vm.$route.query.tab) {
    //   vm.tabs = vm.$route.query.tab
    // } else {
    //   vm.tabs = 'product'
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/main.vue